import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

import "./features/admin/index.css";
import "./css/main.css";

import { browserStorage, initI18n } from "./i18n";
import { isEnglishEnabled, resolveInitialLanguage } from "./i18n/language";
import { rememberOriginalTitle } from "./i18n/pageTitle";

// Before the first render, so nothing paints in the wrong language. This reads
// the stored choice but never writes one: see resolveInitialLanguage.
const initialLanguage = resolveInitialLanguage({
	storage: browserStorage(),
	enabled: isEnglishEnabled(import.meta.env),
});
initI18n(initialLanguage);
rememberOriginalTitle(document.title);
document.documentElement.lang = initialLanguage;

// Prerendered SEO markup is for crawlers only (it is emitted hidden, so it
// never paints); React owns the DOM from here. See scripts/prerender/.
document.getElementById("seo-shell")?.remove();

ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
